import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const PrivateRoute = () => {
  // Only check authentication flags - token is in HTTP-only cookie
  const isAuthenticated = localStorage.getItem('authenticated') === 'true';
  const hasLogin = localStorage.getItem('login') === 'true';
  
  if (!isAuthenticated || !hasLogin) {
    // Clear any stale authentication data
    localStorage.removeItem('login');
    localStorage.removeItem('authenticated');
    localStorage.removeItem('Name');
    localStorage.removeItem('profileURL');
    
    return <Navigate to={`${process.env.PUBLIC_URL}/login`} replace />;
  }
  
  return <Outlet />;
};

export default PrivateRoute;
